<template>
    <ul class="upgrade-row">
        <li class="upgrade-row-name">
            <div>{{ participant.user_name }}</div>
        </li>
        <li class="upgrade-row-tick">
            <input ref="byteEl" type="checkbox" name="byte" value="Byte" :checked="hasByteBadge"
                @change="upgradeClicked">
        </li>
        <li class="upgrade-row-tick">
            <input ref="kiloEl" type="checkbox" name="kilo" value="Kilo" :checked="hasKiloBadge"
                @change="upgradeClicked">
        </li>
        <li class="upgrade-row-tick">
            <input ref="megaEl" type="checkbox" name="mega" value="Mega" :checked="hasMegaBadge"
                @change="upgradeClicked">
        </li>
        <li class="upgrade-row-tick">
            <input ref="gigaEl" type="checkbox" name="giga" value="Giga" :checked="hasGigaBadge"
                @change="upgradeClicked">
        </li>
    </ul>
</template>

<script setup>
import { ref, computed } from "vue";
import { globalState } from '@/scripts/store';

const byteEl = ref(null),
    kiloEl = ref(null),
    megaEl = ref(null),
    gigaEl = ref(null);

const emit = defineEmits(['upgradeChanged']);

const props = defineProps({
    participant: Object
});

const hasByteBadge = computed(() => {
    return hasUpgradeBadge('byte');
})

const hasMegaBadge = computed(() => {
    return hasUpgradeBadge('mega');
})

const hasKiloBadge = computed(() => {
    return hasUpgradeBadge('kilo');
})

const hasGigaBadge = computed(() => {
    return hasUpgradeBadge('giga');
})

function hasUpgradeBadge(type) {
    const studentUuid = props.participant.userData?.studentUuid || props.participant.user_name;
    return globalState.value.studentUpgradeBadges[studentUuid]?.includes(`upgrade-${type}`);
}

function upgradeClicked(e) {
    var checked = e.target.checked;
    changeUpgrade(e.target.value, checked);
}

function changeUpgrade(type, achieved, el) {
    var changed = true;

    if (el) {
        if (el.checked === achieved) {
            changed = false;
        }
        else {
            el.checked = achieved;
        }
    }

    if (changed) {
        emit('upgradeChanged', { participant: props.participant, type: type, achieved: achieved });
    }
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.upgrade-row {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0.25vh 0;

    li {
        input {
            margin: 0 5px;
        }
    }

    &-tick {
        width: 30px;
        text-align: center;
    }

    &-name {
        flex-grow: 1;
        overflow: hidden;

        &-inner {
            display: flex;
            min-width: 0;
        }

        div {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
</style>